module.exports = __webpack_public_path__ + "media/4x3/gb-d3ddd602.svg";